module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPHBhdGggZmlsbD0iIzAwN2ZmZiIgZD0iTTAgMGg2NDB2NDgwSDB6Ii8+CiAgPHBhdGggZD0iTTI4LjggOTZIOTZsMjAuOC02Ny4yTDEzNy42IDk2aDY3LjJsLTU0LjQgNDEuNiAyMC44IDY3LjItNTQuNC00MS42LTU0LjQgNDEuNiAyMC44LTY3LjJMMjguOCA5NnpNNjAwIDBMMCAzNjB2MTIwaDQwbDYwMC0zNjBWMGgtNDAiIGZpbGw9IiNmN2Q2MTgiLz4KICA8cGF0aCBkPSJNNjQwIDBMMCAzODR2OTZMNjQwIDk2VjAiIGZpbGw9IiNjZTEwMjEiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/cd.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/cd.svg
// module chunks = 0